import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DatePipe } from './pipes/date.pipe';
import { GeneralFilterPipe } from './pipes/general-filter.pipe';

const PIPES = [
  GeneralFilterPipe,
  DatePipe
];

const EXTERNAL_PROVIDERS = [
  MessageService
];

@NgModule({
  imports: [
      CommonModule
  ],
  exports: [
    ...PIPES
  ],
  declarations: [...PIPES],
  providers: [...PIPES, ...EXTERNAL_PROVIDERS]
})
export class DataModule {
  constructor() {
  }
}
